import { render, staticRenderFns } from "./quotaRange.vue?vue&type=template&id=1974db58&scoped=true&"
import script from "./quotaRange.vue?vue&type=script&lang=js&"
export * from "./quotaRange.vue?vue&type=script&lang=js&"
import style0 from "./quotaRange.vue?vue&type=style&index=0&id=1974db58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974db58",
  null
  
)

export default component.exports